export default "__VITE_ASSET__7136ec50__"